<template>
  <div id="assist__video">
    <NavFooter />
    <Phone
      v-if="isShowPhone"
      v-on:close="isShowPhone = false"
      v-on:auth="isAuth = $event"
      title="注册一下吧，领取新人礼包"
    />
    <Top
      title="我的视频课奖励"
      icon="anyteachicon anyteach-gift"
      sub="帮助好友赢取 30 天欧美外教少儿英语直播课"
      desc="领取 3 集视频课"
      :noPaddingBottom="false"
    />
    <div v-if="isAllowedAssist === undefined" class="empty">
      <InlineLoading />
    </div>
    <div v-else-if="isAllowedAssist">
      <Error title="暂无奖励" sub="您可以帮助好友助力，或自己发起助力" :showButton="false" />
      <Rule btnType="start" />
    </div>
    <div v-else>
      <Videos v-if="videos.length && isAuth" :videos="videos" />
      <Auth
        v-if="!isAuth"
        msg="绑定手机号即可查看 3 集视频课奖励"
        v-on:phone="isShowPhone = true"
      />
      <Rule btnType="start" />
    </div>
  </div>
</template>

<script>
import Top from "../Top"
import Videos from "./Videos"
import Rule from "../rule/Rule"
import Error from "@/components/assist/Error"
import Phone from "@/components/assist/Phone"
import Auth from "@/components/assist/Auth"
import NavFooter from "@/components/public/footer"

export default {
  name: "AssistVideo",
  components: {
    Top,
    Rule,
    Videos,
    Error,
    Phone,
    Auth,
    NavFooter,
  },
  data() {
    return {
      isAllowedAssist: undefined,
      videos: [],
      isShowPhone: false,
      isAuth: true,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  watch: {
    user: function(val) {
      if (val && !val.mobile) {
        this.isShowPhone = true
      }
    },
  },
  methods: {
    async getStatus() {
      this.isAllowedAssist = await this.$api.assist.STATUS(1)
      if (!this.isAllowedAssist) {
        this.getVideos()
      }
    },
    async getVideos() {
      this.videos = await this.$api.videos.LIST(10)
    },
  },
  mounted() {
    this.getStatus()
  },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";

.empty {
  height: 30vh;
}
#assist__video {
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
}
</style>
